<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px">
  <div class="col col-xs-12">
    <div class="padding-main-side table-filter">
      <!--page body contant -->
      <!--header-->
      <div class="row row-replace add-m-b">
        <div class="col-md-6 col-9 col-p h5">
          <h4 class="heading-super mb-2">
            <i class="fa fa-tachometer"></i> Workplace Permission Dashboard
          </h4>
        </div>
        <div class="col-md-6 col-3 top-corner-items col-p">
          <button class="btn btn-primary btn-sm">
            <i class="fa fa-cloud-download"></i> Download Report
          </button>
        </div>
      </div>
      <!--end header-->

      <!--Vaccination Camp Tracker (Region Wise)  -->
      <div class="row row-replace m-t-10 menu-column border border-rad">
        <div
          class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0"
        >
          <i class="fa fa-link"></i> Workplace Permission Dashboard
        </div>
        <div class="col-12 col-pn">
          <div class="table-responsive">
            <table class="table table-align">
              <thead>
                <th>Region</th>
                <th>Head Count (July 19)</th>
                <th>% Head Count (July 19)</th>
              </thead>
              <tbody>
                <tr>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!--end page body contant -->
    </div>
  </div>
</div>
<!-- /Page Wrapper -->
